import Typography from "@mui/material/Typography";
import { FC } from "react";
import ModalBoxCore from "../../../core-components/modal-box/ModalBoxCore";
import ModalBody from "../../../core-components/modal-box/modal-body/ModalBody";
import ModalHeader from "../../../core-components/modal-box/modal-header/ModalHeader";
import { Box } from "@mui/material";
import CoreButtons from "../../../core-components/button/CoreButtons";
import { BUTTON_COLOR, BUTTON_VARIANT } from "../../../../types/coreButtonTypes";
import "./forgotPasswordModal.scss";

interface ForgotPasswordModalProps {
	open: boolean;
	onClose: () => void;
	onOkay: () => void;
}

const ForgotPasswordModal: FC<ForgotPasswordModalProps> = ({ open, onClose, onOkay }) => {
	return (
		<ModalBoxCore open={open} onClose={onClose} className="forgotPasswordModal">
			<ModalHeader modalHeaderText="Forgot password?" closeModal={onClose} hideCloseButton />
			<ModalBody>
				<Typography variant="h5">
					If your account is registered with this email address, you will receive a password reset link
					shortly.
				</Typography>
			</ModalBody>
			<Box className="btnGroup">
				<CoreButtons
					buttonText="Okay"
					variant={BUTTON_VARIANT.CONTAINED}
					color={BUTTON_COLOR.PRIMARY}
					coreBtnPill={true}
					onclick={onOkay}
					fullWidth
				/>
			</Box>
		</ModalBoxCore>
	);
};

export default ForgotPasswordModal;
